<template>
  <div class="c-navbar__right" v-if="currentMerchant && user">
    <!-- END .c-nav__item -->
    <drop class="c-navbar__item">
      <a role="button" class="c-account" slot="trigger">
        <div class="c-account__media">
          {{ currentMerchant.name }} ({{ user.email }})
        </div>
        <div class="c-account__after">
          <i class="i-caret i-caret--light"></i>
        </div>
      </a>
      <drop-content placement="bottom-end" slot="content">
        <ul class="c-nav c-nav--menus">
          <li class="c-nav__item" v-for="merchant in merchants">
            <a href="#" class="c-nav__link" @click="changeMerchant(merchant.identifier)">{{ merchant.name }}</a>
          </li>
          <li class="c-nav__item" v-if="hasMoreAccounts">
            <a href="#" class="c-nav__link" @click="showModal = true" >Outras contas</a>
          </li>
          <li class="c-nav__divider"></li>
          <li class="c-nav__item">
            <a href="#" class="c-nav__link" @click="logout()">{{ $t('logout.label') }}</a>
          </li>
        </ul>
      </drop-content>
    </drop>

    <modal-accounts v-model="showModal"/>
  </div>
</template>

<script>
  import ModalAccounts from '@/components/shared/ModalAccounts'
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'

  export default {
    data: () => ({
      merchants: [],
      hasMoreAccounts: false,
      showModal: false
    }),
    async mounted () {
      if (this.user.email === undefined) {
        const user = await api.getUser()
        this.addUser(user)
      }

      this.merchants = this.user.merchants
      if (this.merchants.length > 4) {
        this.merchants = this.user.merchants.slice(0, 4)
        this.hasMoreAccounts = true
      }
    },
    methods: {
      ...mapActions('user', [
        'addUser',
        'auth',
        'changeMerchant',
        'logout'
      ])
    },
    computed: {
      ...mapGetters('user', [
        'user'
      ]),
      currentMerchant () {
        if (this.user.merchants === undefined) {
          return false
        }
        return this.user.merchants.find(merchant => merchant.selected === true)
      }
    },
    components: {
      ModalAccounts
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MenuTopBar.vue?477fd5d1